module.exports = __webpack_public_path__ + "static/media/04.1d08d754.png";